import { useLocation, useNavigate, useParams } from 'react-router';
import { useCallback, useMemo } from 'react';
//@ts-ignore
import queryString from 'query-string';

export const useSearchParams = <T extends { [x: string]: string | number | null | undefined } = any>(): { query: Partial<T>, replace: (replacedQuery: T) => void } => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const query = useMemo(() => {
    return {
      ...queryString.parse(location.search),
      ...params,
    };
  }, [params, location.search]);

  const replace = useCallback((replacedQuery: T) => {
    const searchParams = new URLSearchParams(window.location.search);

    Object.entries(replacedQuery).forEach(([key, value]) => {
      const hasParam = searchParams.has(key);

      if (hasParam && value !== null && value !== '') {
        searchParams.set(key, String(value));
      } else if (hasParam && (value === null || value === '')) {
        searchParams.delete(key);
      } else if (!hasParam && value !== null && value !== '') {
        searchParams.set(key, String(value));
      }
    });
    navigate({
      pathname: window.location.pathname,
      search: `?${searchParams}`,
    }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return useMemo(() => {
    return {
      query,
      replace,
    };
  }, [query, replace]);
};
